/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FollowingContainer_viewer$ref = any;
export type FollowingContainerRefetchQueryVariables = {
    readonly after?: string | null;
    readonly loadPortfolioData: boolean;
    readonly selectedItemIds: ReadonlyArray<string | null>;
    readonly hasUserId: boolean;
    readonly userId: string;
    readonly userIds: ReadonlyArray<string | null>;
};
export type FollowingContainerRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FollowingContainer_viewer$ref;
    } | null;
};
export type FollowingContainerRefetchQuery = {
    readonly response: FollowingContainerRefetchQueryResponse;
    readonly variables: FollowingContainerRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "after",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any), v5 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        (v6 /*: any*/),
        (v3 /*: any*/)
    ], v8 = ({
        "kind": "Literal",
        "name": "first",
        "value": 12
    } as any), v9 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        } as any),
        (v8 /*: any*/),
        ({
            "kind": "Literal",
            "name": "types",
            "value": [
                "SEARCH",
                "SELLER",
                "DESIGNER",
                "USER_PREFERENCE"
            ]
        } as any)
    ], v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FollowingContainerRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FollowingContainer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FollowingContainerRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": "trendingCategories",
                            "name": "trending",
                            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "categoryLevels",
                                    "value": 3
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "CATEGORY"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "trendingAttributes",
                            "name": "trending",
                            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
                            "args": [
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "ATTRIBUTE"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v2 /*: any*/)
                        },
                        (v3 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "selectedItemIds"
                                        },
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioItemId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "userId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "favorites",
                                            "storageKey": null,
                                            "args": (v9 /*: any*/),
                                            "concreteType": "favoritesConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "totalResults",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "favoritesEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "cursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Favorite",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "page",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "name",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "query",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "parameters",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Parameters",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "key",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "values",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v3 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "items",
                                                                    "storageKey": "items(first:12,page:0)",
                                                                    "args": [
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "page",
                                                                            "value": 0
                                                                        }
                                                                    ],
                                                                    "concreteType": "FavoriteItemsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "edges",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "FavoriteItemsEdge",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "node",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Item",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v6 /*: any*/),
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "title",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "pdpURL",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "contemporaryTrackingString",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "categoryPath",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "seller",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Seller",
                                                                                            "plural": false,
                                                                                            "selections": (v7 /*: any*/)
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "pricing",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ItemPricing",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "retailPrice",
                                                                                                    "storageKey": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "FinancialAmount",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "alias": null,
                                                                                                            "name": "amount",
                                                                                                            "args": null,
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "photos",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ItemPhoto",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "versions",
                                                                                                    "storageKey": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ItemPhotoVersion",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "alias": null,
                                                                                                            "name": "webPath",
                                                                                                            "args": null,
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                (v3 /*: any*/)
                                                                                            ]
                                                                                        },
                                                                                        (v3 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "__typename",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "pageInfo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "endCursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "hasNextPage",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "favorites",
                                            "args": (v9 /*: any*/),
                                            "handle": "connection",
                                            "key": "FollowingRefetchWrapper_favorites",
                                            "filters": [
                                                "types"
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FollowingContainerRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/FollowingContainerRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '372b13f0468adfe4cb03a8b7cb8d7a50';
export default node;
